import React from 'react'
import { Redirect } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";

const AuthRoutes = (props) => {
  const Component = props.component;
  const userID = localStorage.getItem('userId')
  return (!userID || userID === '' || !props.isLoggedIn ?
    <Component {...props} />
    :
    <Redirect to={{ pathname: `/` }} />
  );
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.isLoggedIn,
  }
}

export default connect(mapStateToProps, null)(withRouter(AuthRoutes));